import { Component, OnInit } from '@angular/core';
import { NgbModalOptions, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2'
import { ClientListService } from './client-list.service';
import { Client } from 'src/app/shared/models/client.model';
import { ClientCreateModalComponent } from '../client-create-modal/client-create-modal.component';
import { Response } from 'src/app/shared/models/response.model';
import { ClientShowkeyModalComponent } from '../client-showkey-modal/client-showkey-modal.component';

@Component({
  selector: 'app-client-list',
  templateUrl: './client-list.component.html',
  styleUrls: ['./client-list.component.scss']
})
export class ClientListComponent implements OnInit {

  clients: Client[];
  modalOptions: NgbModalOptions;

  paginationOffset: number;
  paginationLimit : number;
  paginationTotal : number;
  paginationMaxPageSize: number;
  searchFilter: string;

  private getAllSubscription: Subscription = null;
  private deleteSubscription: Subscription = null;
  private createSubscription: Subscription = null;
  private editSubscription  : Subscription = null;

  constructor(private clientListService: ClientListService,
              private modalService: NgbModal,
              private spinner: NgxSpinnerService,
              private toastr: ToastrService) { }


  /**
   * 
   */
  ngOnInit() {
    this.paginationOffset      = 1;
    this.paginationLimit       = 10;
    this.paginationTotal       = 0;
    this.paginationMaxPageSize = 5;
    this.searchFilter          = '';

    this.modalOptions = {
      backdrop: 'static',
      backdropClass: 'customBackdrop',
      size: 'lg',
    };

    this.getClients();
  }

  /**
   * 
   */
  ngOnDestroy(): void {
    if (this.getAllSubscription !== null) { this.getAllSubscription.unsubscribe(); }
    if (this.deleteSubscription !== null) { this.deleteSubscription.unsubscribe(); }
    if (this.createSubscription !== null) { this.createSubscription.unsubscribe(); }
    if (this.editSubscription   !== null) { this.editSubscription.unsubscribe();   }
  }

  /**
   * Get filtered client list
   */
  getClients() {
    this.spinner.show();

    this.getAllSubscription = this.clientListService.resolveClients(this.searchFilter, this.paginationOffset, this.paginationLimit).subscribe((result: Response) => {
      this.clients         = result.items;
      this.paginationTotal = result.total;

      this.spinner.hide();
    }, (error) => {
      this.spinner.hide();
      this.toastr.error(error);
      console.error(error);
    });
  }

  /**
   *
   */
  onCreate(): void {
    const modalRef = this.modalService.open(ClientCreateModalComponent, this.modalOptions);
    modalRef.result.then((data) => {
      // Se crea el registro
      this.spinner.show();
      this.createSubscription = this.clientListService.create(data).subscribe((result: any) => {
        this.spinner.hide();
        this.getClients();
      }, (error) => {
        this.spinner.hide();
        this.toastr.error(error);
        console.error('Error client created ', error);
      });

    }, (reason) => { });
  }

  /**
   *
   * @param stock
   */
  onEdit(client: Client): void {
    const modalRef = this.modalService.open(ClientCreateModalComponent, this.modalOptions);
    modalRef.componentInstance.client = client;
    modalRef.result.then((data) => {
      // Se edita el registro
      this.spinner.show();
      this.editSubscription = this.clientListService.update(data).subscribe((result: any) => {
        this.spinner.hide();
        this.getClients();
      },
      (error) => {
        this.spinner.hide();
        this.toastr.error(error);
        console.error('Error in client modify', error);
      });

    }, (reason) => { });
  }

  /**
   *
   * @param id
   * @param index
   */
  onDelete(id: number, index: number): void {
    Swal.fire({
      title: '¿Seguro que desea eliminar?',
      text: '¡No podrás recuperar el registro seleccionado!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, Bórralo!',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        this.spinner.show();
        this.deleteSubscription = this.clientListService.delete(id).subscribe(r => {
          this.spinner.hide();
          Swal.fire('Eliminado!', 'El registro ha sido eliminado.', 'success');
          this.clients.splice(index, 1);
        },
        (error) => {
          this.spinner.hide();
          this.toastr.error(error);
          console.error('error to delete item', error);
        });
      }
    });
  }

  /**
   * 
   * @param client 
   */
  onShowKeys(client: Client) {
    const modalRef = this.modalService.open(ClientShowkeyModalComponent, this.modalOptions);
    modalRef.componentInstance.client = client;
    modalRef.result.then((data) => {
      
    }, (reason) => { 
      this.getClients();
    });
  }

  /**
   * 
   * @param term
   */
  onSearch(term: string) {
    this.searchFilter = term;
    this.getClients();
  }

  /**
   * 
   */
  onPageChange() {
    this.getClients();
  }
}
